import React, { memo, PropsWithChildren, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs, TabsList, TabsTrigger } from '../ui/tabs';

export interface FilterTab {
  title: string;
  path: string;
}

interface Props {
  data: FilterTab[];
}

function FilterTabs(props: Props & PropsWithChildren) {
  const { data, children } = props;
  const location = useLocation();
  const navigate = useNavigate();

  const onValueChange = useCallback(
    (value: string) => {
      if (location.pathname !== value) {
        navigate(value);
      }
    },
    [navigate, location.pathname]
  );

  return (
    <Tabs
      value={location.pathname}
      onValueChange={onValueChange}
      className="w-full"
    >
      <TabsList className="grid grid-cols-2 gap-2 w-full bg-transparent h-auto p-0 sm:flex sm:gap-x-2">
        {data.map((tab) => (
          <TabsTrigger
            key={tab.path}
            value={tab.path}
            className="tab-button w-full px-2 py-2 rounded-t-lg font-medium text-xs sm:text-base text-center data-[state=active]:bg-white data-[state=active]:text-black data-[state=inactive]:bg-gray-100 data-[state=inactive]:text-gray-600"
          >
            {tab.title}
          </TabsTrigger>
        ))}
      </TabsList>
      {children}
    </Tabs>
  );
}

export default memo(FilterTabs);
